export default __webpack_public_path__ + "static/media/logo_fes.65a8bfab.png";